import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { ButtonsGroup, HeaderButton } from '../Header/styles';
import { undo, redo } from '../../../containers/Editor/actions';
import { IGNORE_PAGE_CLICK_CLASSNAME, SPREAD_BACKGROUND_CLICK_CLASSNAME } from '../../../containers/Editor/constants';
import Utils from '../../../utils';

interface ButtonsUndoRedoProps {
	isUndoDisabled: boolean;
	isRedoDisabled: boolean;
	isBothDisabled: boolean;
	isSomeTextFieldActive: boolean;
	dispatch: Dispatch<StoreState>;
}

const ButtonsUndoRedo = ({
	isUndoDisabled,
	isRedoDisabled,
	isBothDisabled,
	isSomeTextFieldActive,
	dispatch,
}: ButtonsUndoRedoProps) => {
	const config = [
		{
			icon: 'iconset_uprez_undo',
			isDisabled: isUndoDisabled,
			action: undo,
		},
		{
			icon: 'iconset_uprez_redo',
			action: redo,
			isDisabled: isRedoDisabled,
		},
	];

	React.useEffect(() => {
		if (isBothDisabled || isSomeTextFieldActive) {
			// return if some text field is active to prevent conflicts with built-in history in slate.js library
			return;
		}

		const handleKeyDown = (e: KeyboardEvent) => {
			const isUndoShortcut = (e.ctrlKey || e.metaKey) && e.key === 'z';
			const isRedoShortcut = ((e.ctrlKey || e.metaKey) && e.key === 'y') ||
				(e.ctrlKey || e.metaKey) && e.shiftKey && e.key === 'Z';

			if (!isUndoDisabled && isUndoShortcut) {
				dispatch(undo());
			}

			if (!isRedoDisabled && isRedoShortcut) {
				dispatch(redo());
			}
		};

		window.addEventListener('keydown', handleKeyDown);

		return () => {
			window.removeEventListener('keydown', handleKeyDown);
		};
	}, [isBothDisabled, isUndoDisabled, isRedoDisabled, isSomeTextFieldActive]);

	return (
		<ButtonsGroup>
			{config.map(({ icon, isDisabled, action }) => (
				<HeaderButton
					key={icon}
					iconWidth="20px"
					iconHeight="20px"
					className={`${IGNORE_PAGE_CLICK_CLASSNAME} ${SPREAD_BACKGROUND_CLICK_CLASSNAME}`}
					disabled={isDisabled || isBothDisabled}
					onClick={() => dispatch(action())}
				>
					{Utils.getSvgIcon(icon)}
				</HeaderButton>
			))}
		</ButtonsGroup>
	);
};

export default ButtonsUndoRedo;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonsUndoRedo/index.tsx